
import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'
import { FiCheck } from 'react-icons/fi'

import Modal from '../../../shared/modal/Modal'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import api from '../../../utils/api'

import EditCommission from '../EditCommission'

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'


function ListCommissionRow({ dataArray, myPermissionView, myPermissionEdit, myPermissionDelete, handleOnSuccess, selectItem, handleOnSelectItem, selectedData }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    /* ------------------- Modal useState ----------------------*/

    const [modalEditCommission, setModalEditCommission] = useState(false)
    const [commissionId, setCommissionId] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [selectedItens, setSelectedItens] = useState(selectedData || [])

    async function deleteCommission(id) {
        let msgType = 'success'
        const data = await api.delete(`/commission/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                handleOnSuccess()
                setModalDeleteItem(false)
            }

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)
    }

    const isSelected = (item) => !!selectedItens.find((i) => i._id === item._id)

    const select = (item) => {
        const next = isSelected(item)
            ? selectedItens.filter((i) => i._id !== item._id)
            : [...selectedItens, item]
        setSelectedItens(next)
        handleOnSelectItem(next)
    }

    /* ------------------------ cards ------------------------------ */
    const listArray = () => {
        if (myPermissionView && dataArray && dataArray.length > 0) {
            return dataArray.map((item) => (
                selectItem ? (
                    <div key={item._id} className={`pg-item pg-item-selectable ${isSelected(item) ? 'pg-item-selected' : ''}`} onClick={() => select(item)}>
                        <div className='pg-item-main'>
                            <span className='pg-item-name'>Com. {item.commission}% - Des. {item.discount}%</span>
                        </div>
                        <div className={`pg-item-checkbox ${isSelected(item) ? 'pg-item-checkbox-checked' : ''}`}>
                            <FiCheck size={14} />
                        </div>
                    </div>
                ) : (
                    <div key={item._id} className='pg-item'>
                        <div className='pg-item-main'>
                            <span className='pg-item-name'>Com. {item.commission}% - Des. {item.discount}%</span>
                        </div>

                        <div className='shd-row-box-item-action'>
                            {myPermissionEdit &&
                                <FaPencilAlt className='shd-icon-row-edit' title='Editar' onClick={() => { setCommissionId(item._id); setModalEditCommission(true) }} />
                            }
                            {myPermissionDelete &&
                                <FaTrashAlt className='shd-icon-row-trash' title='Apagar' onClick={() => { setModalDeleteItem(true); setCommissionId(item._id) }} />
                            }
                        </div>
                    </div>
                )
            ))
        }
    }

    return (
        <div>
            {listArray()}

            {!selectItem && (
                <>
                    <Modal
                        modalStatus={modalEditCommission}
                        changeStatus={setModalEditCommission}
                        w={82}
                        content={
                            <EditCommission id={commissionId} handleOnSuccess={() => { setModalEditCommission(false); handleOnSuccess() }} btCancelAction={() => setModalEditCommission(false)} />
                        }
                    />

                    <ConfirmDeleteModal
                        modalStatus={modalDeleteItem}
                        changeStatus={setModalDeleteItem}
                        onConfirm={() => deleteCommission(commissionId)}
                        message="Deseja realmente excluir essa comissão?"
                    />
                </>
            )}

        </div>
    )
}

export default ListCommissionRow
